import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Conclusionrodeo() {
  return (
    <section className="conclusion_rodeo p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={10}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <h2 style={{ color: "#000" }}>Conclusion</h2>
            <p>
              Rodeo Social, by TekRevol, revolutionizes social media management
              with a centralized hub for streamlined collaboration, content
              scheduling, and dynamic gamification. The app's user-friendly
              interface simplifies content management, providing a modern
              solution for businesses of all sizes and industries. Rodeo
              Social's integration of gamification elements motivates team
              members, fostering engagement and competitiveness in social media
              efforts. It stands as a transformative tool, ensuring businesses
              stay agile in the dynamic digital landscape.
            </p>
            <div className="conc_img mt-5">
              <StaticImage
                src="../../../images/case-studies/rodeo/conclusion.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={1051}
                height={689}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Conclusionrodeo;
